import { axisBottom, ScalePoint, Selection } from 'd3';

const AXIS_FONT_FAMILY = '"Nunito Sans", sans-serif';
const AXIS_FONT_SIZE = '10px';

/**
 * Renders a throwaway bottom axis for the scale and returns the widest label in pixels, so a
 * chart can inset its end points enough for centred labels to fit. The probe is removed.
 */
export function measureWidestXLabel(
  svg: Selection<SVGGElement, unknown, null, undefined>,
  x: ScalePoint<string>
): number {
  const probe = svg.append('g').call(axisBottom(x));
  probe.selectAll('text')
    .style('font-family', AXIS_FONT_FAMILY)
    .style('font-size', AXIS_FONT_SIZE);
  const widths = probe.selectAll<SVGTextElement, unknown>('text').nodes().map((node) => node.getComputedTextLength());
  probe.remove();
  return Math.max(0, ...widths);
}

/**
 * Shortens an SVG text node with an ellipsis until it fits maxWidth and keeps the full
 * text as a <title> so it shows on hover. Shared by the chart x-axes so long labels
 * (for example French date abbreviations) never overlap their neighbours.
 */
export function truncateSvgText(node: SVGTextElement, maxWidth: number): void {
  const full = node.textContent ?? '';
  if (node.getComputedTextLength() <= maxWidth) return;

  let text = full;
  while (text.length > 1 && node.getComputedTextLength() > maxWidth) {
    text = text.slice(0, -1);
    node.textContent = `${text}…`;
  }

  const title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
  title.textContent = full;
  node.appendChild(title);
}
